export const PROFILE = {
  ADDRESSES: "العناوين",
  ADDRESS: "العنوان",
  NO_ADDRESS: "لا توجد عناوين خاصة بالمستخدم",
};

export const COUNTRY = {
  SA: "المملكة العربية السعودية ",
};
